import React from 'react'
import { FormattedMessage } from 'react-intl'

export const GOAL_TYPES = {
  distance: {
    key: 'distance_summary.distance_sum',
    label: <FormattedMessage id='goals.iconlabel.dist' defaultMessage='Distance' />,
    icon: 'stat_distance',
  },
  duration: {
    key: 'sessions_summary.sessions_duration_sum',
    label: <FormattedMessage id='goals.iconlabel.duration' defaultMessage='Duration' />,
    icon: 'stat_duration',
  },
  workouts: {
    key: 'sessions_summary.sessions_sum',
    label: <FormattedMessage id='goals.iconlabel.workouts' defaultMessage='Workouts' />,
    icon: 'stat_workouts',
  },
  energy: {
    key: 'energy_expended_summary.energy_expended_sum',
    label: <FormattedMessage id='goals.iconlabel.cals' defaultMessage='Energy Burned' />,
    icon: 'stat_calories',
  },
}

export const GOAL_ACTIVITY = {
  'sport.cycling': <FormattedMessage id='goal.ride' defaultMessage='Ride ' />,
  'sport.running': <FormattedMessage id='goal.run' defaultMessage='Run ' />,
  'sport.walking': <FormattedMessage id='goal.walk' defaultMessage='Walk ' />,
}

export const GOAL_PERIODS = {
  'P1W': <FormattedMessage id='goal.freq.week' defaultMessage=' per week' />,
}

export const USER_GOAL_SUGGESTIONS = [
  {
    'name': (
      <FormattedMessage
        id='goal.sugg.started.name'
        defaultMessage='Just Getting Started' />
    ),
    'description': (
      <FormattedMessage
        id='goal.sugg.started.desc'
        defaultMessage='Any Activity 2 times / week' />
    ),
    'body': {
      'period': 'P1W',
      'scope': 'sessions',
      'operator': 'gte',
      'data_type_field': 'sessions_summary.sessions_sum',
      'value': 2,
    },
  },
  {
    'name': (
      <FormattedMessage
        id='goal.sugg.upnotch.name'
        defaultMessage='Take It Up A Notch' />
    ),
    'description': (
      <FormattedMessage
        id='goal.sugg.upnotch.desc'
        defaultMessage='Any Activity 3 times / week' />
    ),
    'body': {
      'period': 'P1W',
      'scope': 'sessions',
      'operator': 'gte',
      'data_type_field': 'sessions_summary.sessions_sum',
      'value': 3,
    },
  },
  {
    'name': (
      <FormattedMessage
        id='goal.sugg.highgear.name'
        defaultMessage='Kick It Into High Gear' />
    ),
    'description': (
      <FormattedMessage
        id='goal.sugg.highgear.desc'
        defaultMessage='Any Activity 4 times / week' />
    ),
    'body': {
      'period': 'P1W',
      'scope': 'sessions',
      'operator': 'gte',
      'data_type_field': 'sessions_summary.sessions_sum',
      'value': 4,
    },
  },
]
